import { useState } from 'react';
import { Box, makeStyles, Modal } from '@material-ui/core';
import PropTypes from 'prop-types';

import Buttons from '../Buttons';
import Headers from '../Headers';
import NotesCard from '../NotesCard';

import SkeletonContainerText from './SkeletonContainerText';
import Text from './Text';

const useStyles = makeStyles((theme) => ({
  modal: {
    padding: theme.spacing(30, 40),
  },
}));
function ContainerText({ data }) {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModalNotes = () => {
    setOpenModal(!openModal);
  };
  return (
    <Box>
      {data !== undefined ? (
        <>
          <Box className={classes.textButtonsContainer}>
            <Headers actions={handleOpenModalNotes} />
            <Text textContent={data.value} />
          </Box>
          <Buttons />
          <Modal open={openModal} onClose={handleOpenModalNotes} className={classes.modal}>
            <Box>
              <NotesCard close={handleOpenModalNotes} />
            </Box>
          </Modal>
        </>
      ) : <SkeletonContainerText />}
    </Box>
  );
}

export default ContainerText;

ContainerText.propTypes = {
  data: PropTypes.objectOf(PropTypes.string).isRequired,
};
